import {
  ref, watch, computed,
} from '@vue/composition-api';
import axios from 'axios'
import moment from 'moment/moment';
import store from '@/store';
import { showToast, useRouter } from '@/@core/utils/utils';

export default function useCategory(context) {
  const { route } = useRouter();
  const articleId = ref(0)
  const articleData = ref(null)
  const showPreview = ref(false)
  const loading = ref(false)
  const perPage = ref(20)
  const total = ref(0)
  const from = ref(0)
  const to = ref(0)
  const allowResetCurrentPage = ref(false)
  const allowRefetchPaginate = ref(true)
  const currentPage = ref(1)
  const searchQuery = ref('')
  const localSearchQuery = ref('')
  const itemsData = ref([]);
  const dataArticleType = ref([])
  const department_id = ref('')
  const start_date = ref('');
  const bookDate = ref('');
  const end_date = ref('');
  const article_type = ref('')
  const refListTable = ref(null)
  const dataDepartment = ref([])
  const currentSlug = ref('')
  const category_id = ref('')
  const dataCategory = ref([])
  const category = ref({})
  const resultData = ref({})
  const dataPhongBan = ref([])
  const department_unit = ref('')
  const showMode = ref('list')
  const classShowMode = 'show_list_view'
  const loadDateRange = ref('')
  // const dataMeta = computed(() => ({
  //   from: from.value,
  //   to: to.value,
  //   of: total.value,
  // }))
  const Imgsize = computed({
    get() {
      return store.state.home.bannerMinHeight
    },
    set(val) {
      store.dispatch('home/setHeight', val)
    },
  });
  const tableColumns = ref([
    { key: 'title', sortable: false, label: 'Tiêu đề' },
    { key: 'published_at', label: 'Thời gian', thAttr: { width: '8%' } },
    {
      key: 'make_news', label: 'Làm tin', tdClass: 'text-center', thAttr: { width: '8%' }, thClass: 'text-center',
    },
    {
      key: 'unit', label: 'Đơn vị', tdClass: 'text-center', thAttr: { width: '10%' }, thClass: 'text-center',
    },
    {
      key: 'depart_read', label: 'Phòng', tdClass: 'text-center', thAttr: { width: '12%' }, thClass: 'text-center',
    },
  ]);
  const shortcuts = ref([
    { text: 'Hôm nay', onClick: () => [new Date(), new Date()] },
    { text: 'Hôm qua', onClick: () => [new Date(Date.now() - 3600 * 1000 * 24), new Date()] },
    { text: 'Tuần trước', onClick: () => [new Date(Date.now() - 7 * 24 * 3600 * 1000), new Date()] },
    { text: 'Tháng hiện tại', onClick: () => [new Date(now.getFullYear(), now.getMonth(), 1), new Date(now.getFullYear(), now.getMonth() + 1, 0)] },
    { text: 'Tháng trước', onClick: () => [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()] },
    { text: 'Năm hiện tại', onClick: () => [moment().startOf('year').toDate(), moment().endOf('year').toDate()] },
  ])

  const onWindowScroll = () => {
    const curr = window.pageYOffset;

    if (window.scrollY <= 20) {
      if (document.querySelector('#headerBanerCategory')) {
        document.querySelector('#headerBanerCategory').classList.remove('fixBanner');
      }
      if (document.querySelector('#headerBaner')) {
        document.querySelector('#headerBaner').classList.remove('fixBanner');
      }
    } else if (window.scrollY > 20 || currentSlug.value !== '/') {
      if (document.querySelector('#headerBanerCategory')) {
        document.querySelector('#headerBanerCategory').classList.add('fixBanner');
        Imgsize.value = 85
      }
      if (document.querySelector('#headerBaner')) {
        document.querySelector('#headerBaner').classList.add('fixBanner');
        Imgsize.value = 85
      }
    }
  }

  const fetchAllDepartment = () => {
    store.dispatch('home/fetchAllDepartment', {
      department_unit: department_unit.value,
    })
      .then(response => {
        const result = response.data;
        if (result.code === 200) {
          dataDepartment.value = result.data.dataUnit
          dataPhongBan.value = result.data.phongban
        }
      });
  };
  const fetchAllArticleType = () => {
    store.dispatch('home/fetchAllArticleType', {
    })
      .then(response => {
        const result = response.data;
        if (result.code === 200) {
          dataArticleType.value = result.data
        }
      });
  };
  const fetchAll = (isPaginate = 0) => {
    if (!currentSlug.value) {
      return;
    }
    if (!isPaginate) {
      loading.value = true;
    }
    if (allowRefetchPaginate.value) {
      total.value = 0;
    }
    store.dispatch('home/fetchData', {
      keyword: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      slug: currentSlug.value,
      department_id: department_id.value,
      department_unit: department_unit.value,
      start_date: start_date.value,
      end_date: end_date.value,
      article_type: article_type.value,
      book_date: bookDate.value,
      isPaginate,
    })
      .then(response => {
        loading.value = false
        const result = response.data;
        if (result.code === 200) {
          if (isPaginate) {
            from.value = result.data.from;
            // to.value = result.data.to;
            total.value = result.data.total;
          } else {
            setTimeout(() => {
              if (allowRefetchPaginate.value) {
                allowRefetchPaginate.value = false
                fetchAll(1);
              }
            }, 100);

            itemsData.value = result.data.data
            resultData.value = result

            to.value = result.data.data ? result.data.data.length : 0;

            if (result.data.config && Object.keys(result.data.config).length > 0) {
              const { config } = result.data;
              if (config.dataCategory) {
                dataCategory.value = config.dataCategory
              }
              if (config.category) {
                category.value = config.category
                category_id.value = (config.category) ? config.category.id : ''
              }
            }
          }
        } else {
          itemsData.value = []
          showToast(result.message, { variant: 'danger' })
        }
      })
  }
  const updateSearchQuery = () => {
    searchQuery.value = localSearchQuery.value
    fetchAll(currentSlug.value)
    fetchAllDepartment()
  }
  const switchMode = (mode) => {
    if (mode === 'list') {
      showMode.value = 'list'
    } else {
      showMode.value = 'grid'
    }
    return showMode.value
  }
  const capFirst = (str) => {
    const str1 = (str || '').toLowerCase()
    if (str1[0] !== undefined) {
      return str1[0].toUpperCase() + str1.slice(1);
    }
    return str
  }
  const compactShowPart = (data) => data.split(', ').splice(0, 10).join(',')
  const extraShowPart = (data) => data.split(', ').splice(10)
  const lengthPart = (data) => data.split(', ').splice(10).length
  const renderClassTitleView = (item) => {
    // 1. Tin bình thường mầu đen
    // 2. Tin đã click màu ghi
    // 3. Tin hot màu đỏ tười có iconhot
    // 4. TIn đã lấy màu nâu đỏ có icon xanh
    // 5. Tin hot đã click màu ghi có icon hot
    // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
    let classTitle = 'class_title_detail_normall';
    if (item.hot) {
      if (item.is_get) { // đã lấy thì đã đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_hot_get_view'
        } else {
          classTitle = 'class_title_detail_hot_get_notview'
        }
      } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_hot_notget_view'
        } else {
          classTitle = 'class_title_detail_hot_notget_notview' // tin hot chưa lấy chưa đọc
        }
      }
    } else if (!item.hot) {
      if (item.is_get) { // tin đã lấy thì đã đọc
        if (item.is_view) {
          classTitle = 'class_title_detail_nothot_get_view'
        } else {
          classTitle = 'class_title_detail_nothot_notget_notview'
        }
      } else if (!item.is_get) {
        if (item.is_view) { // tin bt nhưng đã xem chưa lấy
          classTitle = 'class_title_detail_nohot_notget_view'
        } else {
          classTitle = 'class_title_detail_nohot_notget_notview'
        }
      }
    }

    return classTitle;
  }
  const onViewArticle = (id) => {
    if (id && articleData.value && articleData.value.id === id) {
      articleData.value.is_view = true
    }
  }
  const onReadArticle = (id) => {

    if (id && articleData.value && articleData.value.id === id) {
      articleData.value.is_read = true
      articleData.value.is_get = true
      //console.log('onReadArticle articleData.value.is_read', articleData.value.is_read);
    }
  }

  const onViewArticle2 = (id) => {
    if (id && articleData.value && articleData.value.id === id) {
      articleData.value.is_view = true
    }
  }
  const onReadArticle2 = (id) => {
    if (id && articleData.value && articleData.value.id === id) {
      articleData.value.is_read = true
      articleData.value.is_get = true
      //console.log('onReadArticle articleData.value.is_read', articleData.value.is_read);
    }
  }

  const dataMeta = computed(() => {
    const localItemsCount = perPage.value
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: total.value,
    }
  })

  return {
    loading,
    perPage,
    total,
    from,
    to,
    dataMeta,
    allowResetCurrentPage,
    allowRefetchPaginate,
    currentPage,
    searchQuery,
    localSearchQuery,
    itemsData,
    dataArticleType,
    department_id,
    start_date,
    bookDate,
    end_date,
    article_type,
    refListTable,
    dataDepartment,
    currentSlug,
    category_id,
    dataCategory,
    category,
    resultData,
    dataPhongBan,
    department_unit,
    showMode,
    classShowMode,
    loadDateRange,
    updateSearchQuery,
    Imgsize,
    tableColumns,
    shortcuts,
    fetchAll,
    fetchAllArticleType,
    fetchAllDepartment,
    onWindowScroll,
    switchMode,
    capFirst,
    compactShowPart,
    extraShowPart,
    lengthPart,
    renderClassTitleView,
    articleId,
    articleData,
    showPreview,
    onViewArticle,
    onReadArticle,
  };
}
